import {getCustomerSlotDetails} from "../../services/SessionStorage";
import config from "../../../config";
/**
 * Returns str with only printable ASCII characters.
 *
 * @param {string} str The string with both printable and non-printable ASCII characters.
 */
function _getPrintableASCIIString(str) {
  return str.replace(/[^\x20-\x7E]+/g, "");
}

export const validateRUT = (rut) => {
  if (!rut) {
    return false;
  }
  rut = _getPrintableASCIIString(rut);
  const [validator, ...number] = rut.replace(/[.-]/g, "").split("").reverse();
  const reNumber = /^\d{8}$/;
  const reValidator = /^[\dkK]{1}$/;
  if (number.length === 7) number.push("0");
  if (!reNumber.test(number.join("")) || !reValidator.test(validator)) {
    return false;
  }
  const multiplier = [2, 3, 4, 5, 6, 7, 2, 3];
  const acc = number.reduce(
    (previousValue, currentValue, currentIndex) =>
      previousValue + +currentValue * multiplier[currentIndex],
    0
  );
  let dv = 11 - (acc % 11);
  dv = dv === 10 ? "K" : `${dv === 11 ? 0 : dv}`;
  const re = new RegExp(`${dv}`, "i");
  return re.test(validator);
};

export const validateNID = (nid) => {
  if (!nid) {
    return false;
  }
  const re = /^[0-9]+$/;
  return re.test(nid);
};

export const validateminLength = (value, length) => {
  const customerSlotDetails = getCustomerSlotDetails();
  const requiredMinLength = config.phoneLength[customerSlotDetails.country]
    ? config.phoneLength[customerSlotDetails.country].min
    : 5;
  const test = value && value.length >= requiredMinLength;
  return test;
};

export const validateTel = (tel) => {
  if (!tel) {
    return false;
  }
  const re = /^[0-9]+$/;
  return re.test(tel);
};

export const validateCPF = (CPF) => {
  if (!CPF) {
    return false;
  } else if (CPF.length == 14) {
    const regex = /\d{3}\.\d{3}\.\d{3}\-\d{2}/;
    return regex.test(CPF);
  } else {
    return false;
  }
};
export const validateCI = (CI) => {
  if (!CI) {
    return false;
  } else if (CI.length == 9) {
    const regex = /\d{3}\.\d{3}\-\d{1}/;
    return regex.test(CI);
  } else if (CI.length == 11) {
    const regex = /\d{1}\.\d{3}\.\d{3}\-\d{1}/;
    return regex.test(CI);
  } else {
    return false;
  }
};

export const validateEmail = (email) => {
  if (!email) {
    return false;
  }
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export const validateName = (name) => {
  if (!name) {
    return false;
  }
  const re = /^[a-zA-ZáéíñóúüÁÉÍÑÓÚÜ ]*$/;
  return re.test(name);
};

export const validateFormInput = {
  checkIsfilled: (value) => value && value.length > 0,
  checkIsTrue: (expression) => expression,
};

export const parseFormInput = {
  parseOnlyLetterAndNumbers: (expression) =>
    expression.replace(/[^A-Za-z0-9]/g, ""),
  parseLength: (expression, length) => expression.substring(0, length),
};

export const validateDNI = (dni) => {
  if (dni && dni.length > 7 && dni.length < 11) {
    return true;
  } else {
    return false;
  }
};

export const validatePEDNI = (dni) => {
  if (dni && dni.length > 7 && dni.length < 10) {
    return true;
  } else {
    return false;
  }
};

export const validateARDNI = (dni) => {
  if (!dni) {
    return false;
  } else if (dni.length == 9) {
    const regex = /\d{1}\.\d{3}\.\d{3}/;
    return regex.test(dni);
  } else if (dni.length == 10) {
    const regex = /\d{1}\.\d{3}\.\d{3}/;
    return regex.test(dni);
  } else {
    return false;
  }
};

export const removeEverySpace = (textToParse) => {
  const replacedtext = textToParse?.replace(/\s+/g, "");
  return replacedtext;
};

export const validatePhoneNumber = (val) => {
  if (val && val.length === 10) {
    return true;
  } else {
    return false;
  }
};

export const validateLength = (val, lengthExpected) => {
  if (val && val.length === lengthExpected) {
    return true;
  } else {
    return false;
  }
};

export const validatePattern = (val, patternExpected) => {
  if (patternExpected === "numeric") {
    const re = /^[0-9]+$/;
    return re.test(val);
  } else {
    const re = /[^A-Za-z0-9]+$/;
    return re.test(val);
  }
};

export const countryAndIdTypeValidationPattern = (val, validationID) => {
  if (validationID()) {
    return true;
  } else {
    return false;
  }
};

export const validateIdSpecificPattern = (
  val,
  lengthExpected,
  patternExpected,
  countryAndIdTypeValidationPattern
) => {
  if (!val) {
    return false;
  }
  if (countryAndIdTypeValidationPattern === "") {
    if (val.length === lengthExpected) {
      if (patternExpected === "numeric") {
        const re = /^[0-9]+$/;
        return re.test(val);
      } else {
        const re = /^[A-Za-z0-9]+$/;
        return re.test(val);
      }
    } else {
      return false;
    }
  } else {
    let validityCheck = false;
    switch (countryAndIdTypeValidationPattern) {
      case "validateRUT":
        validityCheck = validateRUT(val);
        break;
      case "validateNID":
        validityCheck = validateNID(val);
        break;
      case "validateDNI":
        validityCheck = validateDNI(val);
        break;
      case "validateARDNI":
        validityCheck = validateARDNI(val);
        break;
      case "validatePEDNI":
        validityCheck = validatePEDNI(val);
        break;
      case "validatePhoneNumber":
        validityCheck = validatePhoneNumber(val);
        break;
      case "validateEmail":
        validityCheck = validateEmail(val);
        break;
      case "validateCPF":
        validityCheck = validateCPF(val);
        break;
      case "validateCI":
        validityCheck = validateCI(val);
        break;
      default:
        validityCheck = true;
        break;
    }
    return validityCheck;
  }
};
